import * as types from '../constants/ActionTypes';

/**
 * subTopic: store current display topic list
 * layer: store current topic data layer
 * topics: store topic name for bread crumb
 * topicRef: store selected topic RefId
 */

const initialState = {
  layer: 1,
  subTopics: [],
  topics: {},
  topicRef: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SELECT_TOPIC:
      return { ...state, ...action.payload };
    case types.DELETE_PERSIST_TOPICS:
    case types.CANCEL_EMAIL_FORM_NO_INTENT:
      return { ...initialState, topics: {}, topicRef: {} };
    default:
      return state;
  }
}
